export const HeroVideo = (function () {
	'use strict';

	let $videos;

	function init() {
		$videos = $('.rpmblock--cover-video__video');
		$videos.each(function(){
			events(this);
		});
	}
	
	function events(vid_section) {
		let video = $(vid_section).find('video').get(0);
		let video_image_overlay = $(vid_section).find('.rpmblock--cover-video__fallback');
		let picture = $(vid_section).siblings('picture');
		
		// Find the existing fade-div element outside the vid_section
		let fadeDiv = $('#fade-div');
	
		video.play();
		video.addEventListener('playing', function(){
			$(video_image_overlay).fadeOut();
			picture.css('opacity', '1');
		});
	
		video.addEventListener('ended', function(){
			// Fade out the video section
			$(vid_section).fadeOut();
	
			// Gradually increase the opacity of the fade-div outside the vid_section
			fadeDiv.css({
				opacity: '1',				
				paddingBottom: '0px' // Add your desired bottom padding value
			});
		});
	}
	
	return {
		init: init,
	};
})();
